@let isEnvironmentSelected = isEnvironmentSelected$ | async;
@let brand = brand$ | async;
@let isSmallScreen = isSmallScreen$ | async;
@let machineTypes = machineTypes$ | async;
@let selectedEnvironment = selectedEnvironment$ | async;

<app-compatibility-card>
  <h3>{{ 'compatibility.compatibleMachines.title' | translate }}</h3>
  <h4>{{ 'compatibility.compatibleMachines.subtitle' | translate }}</h4>

  <a
    class="selected-brand"
    [href]="brand?.websiteUrl"
    target="_blank"
    [title]="'compatibility.compatibleMachines.goToBrandWebsite' | translate">
    <div class="brand-name">{{ brand?.name }}</div>
    <div class="brand-logo">
      <img [src]="brand?.logo" alt="brand-logo" />
    </div>

    @if (brand && brand.partnership !== PartnerType.BRONZE) {
      <img
        [src]="
          'assets/images/partnership/badges/' + brand.partnership + '-badge.svg'
        "
        [alt]="brand.partnership + ' partner badge'"
        class="partnership-badge" />
    }
  </a>

  @if (isEnvironmentSelected !== true && isSmallScreen === false) {
    <app-machines-filter-panel
      [allModels]="brand?.models"
      (filterModels)="onApplyFilters($event)" />
  }

  @if (machineTypes.length > 0) {
    <ng-container>
      @for (machineType of machineTypes; track $index) {
        <div>
          @if (isNoEquipmentSelected$ | async) {
            <ng-container>
              @if (!isSmallScreen) {
                <div class="machine-type-title">
                  <span class="icon" [ngClass]="machineType.icon"></span>
                  <span>{{ machineType.name | translate }}</span>
                </div>
              } @else {
                <div class="machine-type-title" appCollapsible>
                  <span>{{ machineType.name | translate }}</span>
                </div>
              }
            </ng-container>
          }

          <div class="columns">
            @for (interactivity of interactivities; track $index) {
              <div class="column">
                <div class="column-header">
                  <span class="model-label">
                    {{ 'compatibility.compatibleMachines.models' | translate }}
                  </span>
                  <div class="column-title">
                    {{ interactivity.name | translate }}
                    <span class="info">
                      <img src="assets/images/svg/information.svg" alt="info" />
                      <span class="tooltip">
                        {{ interactivity.tooltip | translate }}
                      </span>
                    </span>
                  </div>
                </div>

                @if (isEnvironmentSelected) {
                  <div class="separator"></div>
                } @else {
                  <div class="env-header">
                    <div>
                      <span class="icon icon-apple"></span>
                      <span class="icon icon-android"></span>
                      <span class="icon icon-embedded"></span>
                    </div>
                  </div>
                }
                @if (
                  (
                    getModelsByInteractivityAndMachineTypeId$(
                      interactivity.id,
                      machineType.id
                    ) | async
                  ).length > 0
                ) {
                  <div class="column-content">
                    @for (
                      machine of getModelsByInteractivityAndMachineTypeId$(
                        interactivity.id,
                        machineType.id
                      ) | async;
                      track $index
                    ) {
                      <div
                        class="machine"
                        [class.env-selected]="isEnvironmentSelected">
                        <span class="machine-name">
                          {{ machine.name }}
                        </span>

                        @if (!isEnvironmentSelected) {
                          <div class="machine-technologies">
                            <div class="ios">
                              @if (machine.antPlusCompatibility.ios) {
                                <span class="icon icon-ant"></span>
                              }
                              @if (machine.bluetoothCompatibility.ios) {
                                <span class="icon icon-bluetooth"></span>
                              }
                              @if (machine.opticalSensorCompatibility.ios) {
                                <span class="icon icon-optical-sensor"></span>
                              }
                            </div>
                            <div class="android">
                              @if (machine.antPlusCompatibility.android) {
                                <span class="icon icon-ant"></span>
                              }
                              @if (machine.bluetoothCompatibility.android) {
                                <span class="icon icon-bluetooth"></span>
                              }
                              @if (machine.opticalSensorCompatibility.android) {
                                <span class="icon icon-optical-sensor"></span>
                              }
                            </div>
                            <div class="embedded">
                              @if (machine.embeddedCompatibility) {
                                <span class="icon icon-embedded"></span>
                              }
                            </div>
                          </div>
                        } @else {
                          <div class="machine-technologies">
                            @if (
                              machine.antPlusCompatibility[selectedEnvironment]
                            ) {
                              <span class="icon icon-ant"></span>
                            }
                            @if (
                              machine.bluetoothCompatibility[
                                selectedEnvironment
                              ]
                            ) {
                              <span class="icon icon-bluetooth"></span>
                            }
                            @if (
                              machine.opticalSensorCompatibility[
                                selectedEnvironment
                              ]
                            ) {
                              <span class="icon icon-optical-sensor"></span>
                            }
                            @if (machine.embeddedCompatibility) {
                              <span class="icon icon-embedded"></span>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div class="no-result">
                    {{ 'compatibility.noResult' | translate }}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </ng-container>
  } @else {
    <div class="no-model">
      {{ 'compatibility.noModel' | translate | uppercase }}
    </div>
  }
</app-compatibility-card>
